import { render, staticRenderFns } from "./ReportsPagesContainer.vue?vue&type=template&id=06fc13e8&"
import script from "./ReportsPagesContainer.vue?vue&type=script&lang=js&"
export * from "./ReportsPagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports